export interface PlanList {
  id?: string;
  Id?: number;
  PlanName: string;
  Level: number;
  Package: string;
  Platform: number; // Apple(0), Android(1), PlanKey(2)
  Status: number; // Available(0), Using(1), Expired(2)
  RemainDay?: number;
  acode?: number;
  CreateId: number;
  CreateTime: number;
  OrderInfoId?: number;
  KeyNumber?: string;
  IsConfirmed: boolean;
  ActivatedTime?: number;
  Type: number; // Billing Plan(0) & PlanKey(1)
  EmailInfo?: EmailInfo[];
  PlanMgtId: number;
  RegionId?: number;
  IsFree?: boolean;
  Period?: number;
  Grade?: number;
}

export interface PlanListAddParams {
  id?: number;
  Id?: number;
  otp?: string;
  PlanMgtId: number;
  RegionId?: number;
  EmailInfo?: EmailInfo[];
  Period?: number;
  IsFree?: boolean;
}

export interface EmailInfo {
  id?: number;
  Type?: number; // Single E-mail(0), Group E-mail(1)
  Receiver: string;
  ReceiverType: number;
  Note?: string;
}

export interface ConfirmKeyParams {
  otp?: string;
  Id?: number;
}

export interface PlanListParams {
  otp?: string;
  acode?: number;
  Platform?: number; // Apple(0), Android(1), PlanMgt(2)
  Status?: number; // Available(0), Using(1), Expired(2)
  RegionId?: number;
  IsConfirmed?: number;
  syncAccountsInfo?: boolean;
}


